// ボス：ゆっくり追跡、近距離で薙ぎ払い（簡易MVP実装）
import Phaser from 'phaser';
import { Enemy } from '../Enemy';

export class Boss extends Enemy {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'boss');
    // ボスは2フレームの idle/attack 切替
    this.anims.play('boss-idle');
  }

  static defineAnimations(scene: Phaser.Scene): void {
    if (!scene.anims.exists('boss-idle')) {
      scene.anims.create({
        key: 'boss-idle',
        frames: [{ key: 'enemy_boss', frame: 0 }],
        frameRate: 1,
      });
    }
    if (!scene.anims.exists('boss-attack')) {
      scene.anims.create({
        key: 'boss-attack',
        frames: [{ key: 'enemy_boss', frame: 1 }],
        frameRate: 1,
      });
    }
  }

  protected override tryAttack(_px: number, _py: number): void {
    if (this.attackCooldownMs > 0) return;
    this.attackCooldownMs = this.spec().cooldownMs;
    // 攻撃モーション表示
    this.anims.play('boss-attack');
    this.scene.time.delayedCall(280, () => {
      if (this.active) this.anims.play('boss-idle');
    });
  }
}
